import React, { FC } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  button: {
    width: 100,
    backgroundColor: theme.palette.grey[100],
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
    },
  },
}));

const Secondary: FC<ButtonProps> = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Button className={classes.button} {...rest}>
      {children}
    </Button>
  );
};

export default Secondary;
